import { RootStateOrAny, useSelector } from 'react-redux';
import { isLoaded } from 'react-redux-firebase';

import { useMemo } from 'react';
import { getAllCombinedRoomsForSurvey } from '../shared/utilities';
import { RoomProps } from '../types/room';
import useSurvey from './useSurvey';

export function useAllRoomsForFloor(
  floor?: string,
  sortFunction?: (a: any, b: any) => number,
) {
  const survey = useSurvey();

  const rooms = useSelector(
    (state: RootStateOrAny) => state.firestore.ordered.rooms ?? [],
  );
  const areRoomsLoaded = isLoaded(rooms);

  const areRoomsForSelectedFloor = useMemo(() => {
    if (!floor) {
      return true;
    }
    return rooms.every((room) => room?.floor === floor);
  }, [floor, rooms]);

  const isLoading = !areRoomsLoaded || !areRoomsForSelectedFloor;

  const allRooms = useMemo(() => {
    if (isLoading) {
      return [];
    }

    return getAllCombinedRoomsForSurvey(survey, rooms, floor, sortFunction);
  }, [isLoading, survey, rooms, floor, sortFunction]);

  return {
    allRooms: (allRooms as RoomProps[]) || [],
    isLoading,
  };
}
